<template>
  <section id="QuadrupleBanner" class="container">
    <div v-if="customeBanners">
      <div class="grid_banner">
        <figure
          class="QuadrupleBannerFig"
          v-if="customeBanners.first_centerBanner"
        >
          <DynamicLinker
            v-if="customeBanners.first_centerBanner.picture"
            :item="customeBanners.first_centerBanner"
          >
            <img
              loading="lazy"
              :src="customeBanners.first_centerBanner.picture"
              :alt="
                customeBanners.first_centerBanner.slug
                  ? customeBanners.first_centerBanner.slug
                  : ''
              "
            />
          </DynamicLinker>
          <Skeleton v-else></Skeleton>
        </figure>
        <Skeleton v-else></Skeleton>

        <figure
          class="QuadrupleBannerFig"
          v-if="customeBanners.second_centerBanner"
        >
          <DynamicLinker
            v-if="customeBanners.second_centerBanner.picture"
            :item="customeBanners.second_centerBanner"
          >
            <img
              loading="lazy"
              :src="customeBanners.second_centerBanner.picture"
              :alt="
                customeBanners.second_centerBanner.slug
                  ? customeBanners.second_centerBanner.slug
                  : ''
              "
            />
          </DynamicLinker>
          <Skeleton v-else></Skeleton>
        </figure>
        <Skeleton v-else></Skeleton>

        <figure
          class="QuadrupleBannerFig"
          v-if="customeBanners.third_centerBanner"
        >
          <DynamicLinker
            v-if="customeBanners.third_centerBanner.picture"
            :item="customeBanners.third_centerBanner"
          >
            <img
              loading="lazy"
              :src="customeBanners.third_centerBanner.picture"
              :alt="
                customeBanners.third_centerBanner.slug
                  ? customeBanners.third_centerBanner.slug
                  : ''
              "
            />
          </DynamicLinker>
          <Skeleton v-else></Skeleton>
        </figure>
        <Skeleton v-else></Skeleton>

        <figure
          class="QuadrupleBannerFig"
          v-if="customeBanners.fourth_centerBanner"
        >
          <DynamicLinker
            v-if="customeBanners.fourth_centerBanner.picture"
            :item="customeBanners.fourth_centerBanner"
          >
            <img
              loading="lazy"
              :src="customeBanners.fourth_centerBanner.picture"
              :alt="
                customeBanners.fourth_centerBanner.slug
                  ? customeBanners.fourth_centerBanner.slug
                  : ''
              "
            />
          </DynamicLinker>
          <Skeleton v-else></Skeleton>
        </figure>
        <Skeleton v-else></Skeleton>
      </div>
      <div class="swiper sliderBanner">
        <div class="QuadrupleSlidersBanner-content">
          <div class="QuadrupleSlidersBanner-content-item position-relative">
            <div
              class="swiper-container"
              v-if="!disabledSliders.includes('QuadrupleBannerSlider')"
            >
              <div class="swiper-wrapper">
                <div
                  class="swiper-slide"
                  v-if="customeBanners.first_bannerMobile"
                >
                  <figure class="QuadrupleBannerFig">
                    <DynamicLinker
                      v-if="customeBanners.first_bannerMobile.picture"
                      :item="customeBanners.first_bannerMobile"
                    >
                      <img
                        loading="lazy"
                        :src="customeBanners.first_bannerMobile.picture"
                        :alt="
                          customeBanners.first_bannerMobile.slug
                            ? customeBanners.first_bannerMobile.slug
                            : ''
                        "
                      />
                    </DynamicLinker>
                    <Skeleton v-else></Skeleton>
                  </figure>
                </div>
                <Skeleton class="swiper-slide" v-else></Skeleton>

                <div
                  class="swiper-slide"
                  v-if="customeBanners.second_bannerMobile"
                >
                  <figure class="QuadrupleBannerFig">
                    <DynamicLinker
                      v-if="customeBanners.second_bannerMobile.picture"
                      :item="customeBanners.second_bannerMobile"
                    >
                      <img
                        loading="lazy"
                        :src="customeBanners.second_bannerMobile.picture"
                        :alt="
                          customeBanners.second_bannerMobile.slug
                            ? customeBanners.second_bannerMobile.slug
                            : ''
                        "
                      />
                    </DynamicLinker>
                    <Skeleton v-else></Skeleton>
                  </figure>
                </div>
                <Skeleton class="swiper-slide" v-else></Skeleton>

                <div
                  class="swiper-slide"
                  v-if="customeBanners.third_bannerMobile"
                >
                  <figure class="QuadrupleBannerFig">
                    <DynamicLinker
                      v-if="customeBanners.third_bannerMobile.picture"
                      :item="customeBanners.third_bannerMobile"
                    >
                      <img
                        loading="lazy"
                        :src="customeBanners.third_bannerMobile.picture"
                        :alt="
                          customeBanners.third_bannerMobile.slug
                            ? customeBanners.third_bannerMobile.slug
                            : ''
                        "
                      />
                    </DynamicLinker>
                    <Skeleton v-else></Skeleton>
                  </figure>
                </div>
                <Skeleton class="swiper-slide" v-else></Skeleton>

                <div
                  class="swiper-slide"
                  v-if="customeBanners.fourth_bannerMobile"
                >
                  <figure class="QuadrupleBannerFig">
                    <DynamicLinker
                      v-if="customeBanners.fourth_bannerMobile.picture"
                      :item="customeBanners.fourth_bannerMobile"
                    >
                      <img
                        loading="lazy"
                        :src="customeBanners.fourth_bannerMobile.picture"
                        :alt="
                          customeBanners.fourth_bannerMobile.slug
                            ? customeBanners.fourth_bannerMobile.slug
                            : ''
                        "
                      />
                    </DynamicLinker>
                    <Skeleton v-else></Skeleton>
                  </figure>
                </div>
                <Skeleton class="swiper-slide" v-else></Skeleton>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-else>
      <div class="grid_banner">
        <Skeleton class="QuadrupleBannerFig"></Skeleton>
        <Skeleton></Skeleton>
        <Skeleton></Skeleton>
        <Skeleton></Skeleton>
      </div>
      <div class="swiper sliderBanner">
        <div class="QuadrupleSlidersBanner-content">
          <div class="QuadrupleSlidersBanner-content-item position-relative">
            <div
              class="swiper-container"
              v-if="!disabledSliders.includes('QuadrupleBannerSlider')"
            >
              <div class="swiper-wrapper">
                <div class="swiper-slide" v-for="i in 4" :key="i">
                  <Skeleton></Skeleton>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>
<script>
import Swiper from "swiper/swiper-bundle.min";
import Product from "@/parts/Front/components/product/Product";
import DynamicLinker from "@/parts/Front/components/shared/DynamicLinker.vue";
let breakpoints = {
  300: {
    centeredSlides: true,
    centeredSlidesBounds: true,
    slidesPerView: 1.2,
    spaceBetween: 10,
  },
  500: {
    centeredSlides: true,
    centeredSlidesBounds: true,
    slidesPerView: 2.5,
    spaceBetween: 10,
  },
  992: {
    centeredSlides: false,
    centeredSlidesBounds: false,
    slidesPerView: 4,
    spaceBetween: 10,
  },
  1200: {
    centeredSlides: false,
    centeredSlidesBounds: false,
    slidesPerView: 4,
    spaceBetween: 10,
  },
};
export default {
  name: "QuadrupleBannerSlider",
  components: { Product, DynamicLinker },
  inject: ["mediaQueries"],
  data() {
    return {
      slider: null,
    };
  },
  watch: {
    customeBanners: {
      immediate: true,
      handler(customeBanners) {
        if (customeBanners == null) {
          return;
        }
        this.initSlider(true);
      },
    },
  },
  mounted() {
    if (this.$store.getters["front/getHomeData"] != null) this.initSlider(true);
    if (this.$store.getters["front/getAdvertisements"] == null) {
      this.$store.dispatch("front/getAdvertisementsDataFromServer");
    }
  },
  computed: {
    //   products() {
    //     return this.readyProducts;
    //   },
    customeBanners() {
      if (this.$store.getters["front/getAdvertisements"] != null) {
        let advertise = this.$store.getters["front/getAdvertisements"];
        return advertise;
      } else {
        return null;
      }
    },
  },
  methods: {
    initSlider(kill = false) {
      this.initSwiper("QuadrupleBannerSlider", kill, () => {
        if (this.slider) {
          this.slider.destroy();
        }
        this.slider = new Swiper("#QuadrupleBanner .swiper-container", {
          loop: true,
          speed: 500,

          autoplay: {
            delay: 5000,
            disableOnInteraction: false,
          },

          breakpoints,
        });
      });
    },
  },
};
</script>

<style scoped>
.Skeleton {
  height: 240px;
}
#QuadrupleBanner {
  margin-top: 8rem;
}
#QuadrupleBanner .grid_banner {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 1.5rem;
}
.sliderBanner {
  width: 100%;
  display: none;
}
.QuadrupleBannerFig,
.QuadrupleBannerFig img {
  margin: 0;
  width: 100%;
}
@media screen and (max-width: 600px) {
  #QuadrupleBanner .grid_banner {
    display: none;
  }
  .sliderBanner {
    display: inline-block;
  }
}
</style>
